import { render, staticRenderFns } from "./DriversList.vue?vue&type=template&id=b989d0b4&scoped=true&"
import script from "./DriversList.vue?vue&type=script&lang=js&"
export * from "./DriversList.vue?vue&type=script&lang=js&"
import style0 from "./DriversList.vue?vue&type=style&index=0&id=b989d0b4&lang=scss&scoped=true&"
import style1 from "./DriversList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b989d0b4",
  null
  
)

export default component.exports